import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { graphql } from "@apollo/client/react/hoc";
import { DISTRICTS_COMMON_QUERY } from "Services/queries";
import { generateUrl } from "Services/withDefaultParams";
import withDefaultParams from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { generateValidChankUrl, generateStreetPart } from "Helpers/UrlManager";
import { BigBlockStub } from "Layouts/Stubs";
import BenefitsLayout from "Layouts/BenefitsLayout";
import HideBeforeMount from "Layouts/HideBeforeMount";
import SeoAddressLayout from "Layouts/SeoAddressLayout";
import AddressSearchContainer from "Containers/AddressSearchContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import List from "ComponentsUI/List";
import { isMainSiteCode } from "Utils/siteConfig";

@inject("ApplicationModel")
@observer
class Districts extends React.Component {
	componentDidMount() {
		let searcheModel = this.props.ApplicationModel.searcheModel;
		searcheModel.saveToMemoryData();
		// searcheModel.resetData();
	}

	componentWillUnmount() {
		let searcheModel = this.props.ApplicationModel.searcheModel;
		if (!!searcheModel.getCurrentStreet().id) {
			searcheModel.deleteMemoryData();
		} else {
			searcheModel.recoveryMemoryData();
		}
	}

	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(Routes.AddressDistricts.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		let {
			districts,
			settlements,
			region,
			ApplicationModel: {
				currentRegion,
				windowSizeModel: { windowSizes },
				text,
			},
			match: {
				params: { regionUrl },
			},
			seoData,
		} = this.props;
		const siteCode = this.props.ApplicationModel.siteCode;

		let isStub = !districts;

		let searchAddress = <AddressSearchContainer />;

		let benefits = (
			<HideBeforeMount>
				<BenefitsLayout colorless={true} withoutTopMargin={true} />
			</HideBeforeMount>
		);

		let middleComponent = <BigBlockStub />;

		let settleMents = null;
		if (!isStub) {
			let showAlphabet = true;
			let isSwitchView = false;
			let cloneDistricts = JSON.parse(JSON.stringify(districts.data));
			cloneDistricts = cloneDistricts.map((s) => {
				return {
					...s,
					name: s.name.charAt(0).toUpperCase() + s.name.slice(1),
				};
			});
			let sortDistricts = cloneDistricts.sort(function (a, b) {
				if (a.name > b.name) return 1;
				if (a.name < b.name) return -1;
			});
			sortDistricts.map(
				(district) =>
					(district.link = decodeURIComponent(
						generateUrl(Routes.AddressStreets.route, {
							regionUrl: regionUrl,
							districtName: generateValidChankUrl(district.name).toLowerCase(),
							districtId: district.id,
						})
					))
			);
			let cloneSettlements = JSON.parse(JSON.stringify(settlements.settlements));
			cloneSettlements = cloneSettlements.map((s) => {
				return {
					...s,
					name: s.name.charAt(0).toUpperCase() + s.name.slice(1),
					full: s.full.charAt(0).toUpperCase() + s.full.slice(1),
				};
			});
			let sortSettlements = cloneSettlements.sort(function (a, b) {
				if (a.full > b.full) return 1;
				if (a.full < b.full) return -1;
			});

			if (sortSettlements.length > 0) {
				sortSettlements.map(
					(s) =>
						(s.link = decodeURIComponent(
							generateUrl(Routes.AddressStreet.route, {
								regionUrl: regionUrl,
								districtName: generateValidChankUrl(s.district.name).toLowerCase(),
								districtId: s.district.id,
								streetName: generateStreetPart(s),
								streetId: s.id,
							})
						))
				);
				settleMents = (
					<List
						key="settleMents"
						text={text}
						items={[]}
						defaultItems={sortSettlements}
						windowSizes={windowSizes}
						showAlphabet={showAlphabet}
						onItemSelect={this.props.onItemSelect}
						type={"settlements"}
						isSwitchView={isSwitchView}
						listHeader={text.SEO_ADDRESS_SETTLEMENTS_TITLE}
					/>
				);
			}
			// let county = sortDistricts.filter(item => item.parentId == 0);
			let items = [];

			// if (currentRegion.id == 77) {
			//     county.map(item => {
			//         let secondLevel = sortDistricts.filter(
			//             district =>
			//                 district.parentId == item.id &&
			//                 district.parentId != 0
			//         );
			//         console.log("secondLevel", county, secondLevel);
			//         items.push({ name: item.name, s: secondLevel });
			//         if (secondLevel.length > 0) {
			//         }
			//     });
			//     showAlphabet = false;
			//     isSwitchView = false;
			// }

			middleComponent = [
				<List
					key="districts"
					text={text}
					items={items}
					defaultItems={sortDistricts}
					windowSizes={windowSizes}
					showAlphabet={showAlphabet}
					onItemSelect={this.props.onItemSelect}
					type={"districts"}
					isSwitchView={isSwitchView}
					listHeader={text.SEO_ADDRESS_DISTRICTS_TITLE}
					isDistricts={true}
				/>,
			];
			if (settleMents) {
				middleComponent.push(settleMents);
			}
		}

		return (
			<React.Fragment>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				{searchAddress}
				<TopProviderContainer backgroundNone={true} />
				<SeoAddressLayout
					topComponent={null}
					middleComponent={middleComponent}
					settlementsComponent={middleComponent}
				/>
			</React.Fragment>
		);
	}
}

export default withRouter(
	withDefaultParams(
		graphql(DISTRICTS_COMMON_QUERY, {
			skip: (ownProps) => {
				return !ownProps.match.params.regionUrl;
			},
			options: (props) => {
				let {
					match: {
						params: { regionUrl },
					},
				} = props;
				return {
					variables: {
						regionUrl,
					},
				};
			},
			props: ({ data }) => {
				if (data.districts) {
					return data;
				}
				return null;
			},
		})(Districts)
	)
);
